<!-- //
数据服务-接口审批列表
@auth xuyd
@date 2024-05-01
//-->
<template>
  <page-layout layout="C">
    <div class="layout-search" style="display: flex; flex-direction: row; justify-content: space-between">
      <el-form @submit.native.prevent ref="refQueryForm" :model="queryParams" size="small" :inline="true"
               label-width="100px">
        <el-form-item prop="search">
          <el-input
              v-model="queryParams.search"
              placeholder="请输入检索内容（接口编号、接口名、接口描述）"
              style="width: 320px;text-align: right;"
              maxlength="20"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
          <el-button type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display:flex; justify-content: right;">
      </div>
    </div>

    <!-- 结果区域 -->
    <div class="layout-result" style="height: calc(100% - 63px);">
      <DynamicTable :query-params="queryParams"
                    :selection="true"
                    :data="tableData"
                    :metas="tableMetas"
                    @reload="getList">
        <div slot-scope="{row, item}">
          <el-button size="small" type="text" @click="handleApprove(row)">审批</el-button>
        </div>
      </DynamicTable>
    </div>
  </page-layout>
</template>

<script>
import ApiDesignApi from '@/api/datasvc/apiDesign.api.js';
import ApiGroup from '@/components/Api/ApiGroup';

export default {
  name: 'ViewApiDesignList',
  components: {ApiGroup},
  dictTypes: [
    {dictType: 'API_STATUS', dataType: Number},
    {dictType: 'ONLINE_STATUS', dataType: Number},
  ],
  data() {
    return {
      defaultProps: {children: 'children', label: 'name', countProp: 'apiCount'},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: null,
        isAsc: null,
        search: null,
        designUser: null,
        apiStatus: [],
        onlineStatus: [],
      },
      tableData: {
        tableLoading: false,
        records: [],
        total: 0,
      },
      tableMetas: [
        {prop: 'apiNum', label: "接口编码", dataType: "link", linkUrl: 'ViewApiDesignDetail',linkType: 'blank',  width: 80},
        {prop: 'apiName', label: "接口名", dataType: "link", linkUrl: 'ViewApiDesignDetail', linkType: 'blank', minWidth: 120, sortable: true},
        {prop: 'apiComment', label: "接口名称（中文）", minWidth: 140},
        {prop: 'groupName', label: "分组名", minWidth: 120, sortable: true},
        {prop: 'latestApiVersion', label: "最新版本号", minWidth: 100, dataType: 'custom',customComp: "Version"},
        {prop: 'apiStatus', label: "状态", dataType: "dict", dictType: 'API_STATUS', width: 100, filterable: true, filterComp: "FunnelMultiSelect"},
        {prop: 'designUser', label: "设计人", width: 120, dataType: 'custom', sortable: true, filterable: true, filterComp: "FunnelRemoteSelect",
          funcRender: (h, {row})=> {
            return [h('span', row.designUserName? row.designUserName + '('+ row.designUser +')' : '')]
          }
        },
        {prop: 'apiDesc', label: "接口描述", minWidth: 180},
        {prop: 'designTime', label: "创建时间", width: 160, dataType: 'date', sortable: true},
        {prop: '', label: "操作", width: 80, fixed: 'right'},
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      ApiDesignApi.searchApproveList(this.queryParams).then(resp => {
        this.tableData.records = resp.data.records.map(item => {
          item.loading = false;
          return item;
        });
        this.tableData.total = resp.data.total;
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm("refQueryForm");
      this.$refs.refQueryForm.resetFields();
      this.queryParams.orderByColumn = null;
      this.queryParams.isAsc = null;

      // =========重置(S)========
      this.queryParams.designUser = null;
      this.queryParams.apiStatus = [];
      this.queryParams.onlineStatus = [];
      // =========重置(E)========
      this.handleQuery();
    },

    /** 排序触发事件 */
    handleSortChange(column) {
      // console.log("----handleSortChange---->", JSON.stringify(column));
      if (column.order === 'ascending') {
        this.queryParams.isAsc = true;
        this.queryParams.orderByColumn = column.prop;
      } else if (column.order === 'descending') {
        this.queryParams.isAsc = false;
        this.queryParams.orderByColumn = column.prop;
      } else {
        this.queryParams.isAsc = null;
        this.queryParams.orderByColumn = null;
      }
      this.getList();
    },
    handleApprove(row) {
      this.$router.push({name: 'ViewApiApproveEdit', query: {id: row.id}});
    },
  }
}
</script>

<style lang="less" scoped>

</style>
